import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FaHeart, FaArrowRight, FaUsers, FaShieldAlt, FaRocket, FaCheckCircle } from 'react-icons/fa';
import LandingNavbar from '../../components/layout/LandingNavbar';
import LandingFooter from '../../components/layout/LandingFooter';
import './LandingPage.css';

const LandingPage = () => {
  const navigate = useNavigate();

  const handleJoinCommunity = () => {
    navigate('/login');
  };

  return (
    <div className="landing-page">
      <LandingNavbar />
      
      <main className="landing-main">
        <div className="landing-hero">
          <div className="hero-content">
            <div className="hero-badge">
              <FaHeart className="badge-icon" />
              <span>La plateforme de rencontre #1</span>
            </div>
            
            <h1 className="hero-title">
              Trouvez l'amour
              <span className="highlight">authentique</span>
              <span className="heart-emoji">💕</span>
            </h1>
            
            <p className="hero-subtitle">
              Rejoignez des milliers de cœurs à la recherche de connexions sincères. 
              Lova vous accompagne dans votre quête de l'âme sœur avec des matches 
              compatibles et des moments magiques.
            </p>
            
            <div className="hero-features">
              <div className="hero-feature">
                <div className="feature-icon-wrapper">
                  <FaCheckCircle />
                </div>
                <span>Profils vérifiés</span>
              </div>
              <div className="hero-feature">
                <div className="feature-icon-wrapper">
                  <FaRocket />
                </div>
                <span>Matches instantanés</span>
              </div>
              <div className="hero-feature">
                <div className="feature-icon-wrapper">
                  <FaShieldAlt />
                </div>
                <span>100% sécurisé</span>
              </div>
            </div>
            
            <button className="cta-button" onClick={handleJoinCommunity}>
              <span>Rejoindre la communauté Lova</span>
              <FaArrowRight className="cta-icon" />
            </button>
            
            <div className="hero-stats">
              <div className="stat">
                <h3>50,000+</h3>
                <p>Couples formés</p>
              </div>
              <div className="stat-divider"></div>
              <div className="stat">
                <h3>95%</h3>
                <p>Satisfaction</p>
              </div>
              <div className="stat-divider"></div>
              <div className="stat">
                <h3>24/7</h3>
                <p>Support dédié</p>
              </div>
            </div>
          </div>
          
          <div className="hero-visual">
            <div className="floating-card card-1">
              <FaHeart className="card-icon" />
              <span>Nouveau match !</span>
            </div>
            <div className="floating-card card-2">
              <FaUsers className="card-icon" />
              <span>+1,200 en ligne</span>
            </div>
            <div className="hero-illustration">
              <div className="heart-pulse">💕</div>
            </div>
          </div>
        </div>
        
        <div className="landing-background">
          <div className="floating-heart heart-1">❤️</div>
          <div className="floating-heart heart-2">💕</div>
          <div className="floating-heart heart-3">💖</div>
          <div className="floating-heart heart-4">💗</div>
          <div className="floating-heart heart-5">💓</div>
          <div className="floating-heart heart-6">💘</div>
          <div className="floating-heart heart-7">💝</div>
          <div className="floating-heart heart-8">💞</div>
        </div>
      </main>
      
      <LandingFooter />
    </div>
  );
};

export default LandingPage;
